import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  showAlert as dispatchShowAlert,
  showConfirm as dispatchShowConfirm,
  showPrompt as dispatchShowPrompt,
} from "@/features/shepDialog/shepDialogSlice";

/**
 * hook to use ShepDialogs simply
 * The dialogs are rendered once in App.js
 *
 * Usage:
 * const { showAlert, showConfirm, showPrompt } = useShepDialogs();
 *
 * showAlert("Something happened!");
 * showAlert("Something happened!", { title: "Notice", variant: "info" });
 *
 * showConfirm("Are you sure?", { onConfirm: () => doSomething() });
 */
const useShepDialogs = () => {
  const dispatch = useDispatch();

  const showAlert = useCallback(
    (message, options = {}) => dispatch(dispatchShowAlert({ message, ...options })),
    [dispatch]
  );

  const showConfirm = useCallback(
    (message, options = {}) => dispatch(dispatchShowConfirm({ message, ...options })),
    [dispatch]
  );

  const showPrompt = useCallback(
    (message, options = {}) => dispatch(dispatchShowPrompt({ message, ...options })),
    [dispatch]
  );

  return { showAlert, showConfirm, showPrompt };
};

export default useShepDialogs;

